<template>
  <transition :name="pageType == 2 ? 'app-modal' : ''">
    <div class="modal-wrapper" v-if="showModal && step !== 2">
      <div v-if="step == 1">
        <div class="modal-box" v-if="isMobile">
          <div class="box-top">
            <img :src="moduleData.img_url" class="form-header">
            <div class="form-txts">
              <div class="form-txt-title">
                尊敬的诺亚财富用户：
              </div>
              <div class="form-txt-ctt">
                根据《私募投资基金募集行为管理办法》规定，即日起诺亚仅向特定合格投资者，宣传推介私募投资基金产品。特此公告！
              </div>
              <div class="form-txt-sign">
                诺亚财富
              </div>
              <div class="protocol">
                <input type="checkbox" checked="checked" class="registerCheckbox">
                <p>
                  本人承诺符合特定
                  <a href="/qualification.html" target="_blank">
                    《合格投资者标准》
                  </a>
                  条件
                </p>
              </div>
            </div>
          </div>
          <div class="form-rings"></div>
          <div class="form-box">
            <div class="form-lists">
              <div class="form-list name">
                <input
                  type="text"
                  v-model="name"
                  placeholder="请输入您的姓名"
                  @blur="verifyName"
                />
                <p class="notice">{{ notice1 }}</p>
              </div>
              <div class="form-list tel">
                <input
                  type="tel"
                  v-model="phone"
                  placeholder="请输入您的手机号"
                  maxlength="11"
                  @blur="verifyPhone"
                />
                <p class="notice">{{ notice2 }}</p>
              </div>
              <div class="form-list vercode clearfix">
                <input
                  type="tel"
                  v-model="phoneCode"
                  maxlength="6"
                  placeholder="请输入验证码"
                  @blur="verifyPhoneCode"
                />
                <span @click="getPhoneCode">{{ getPh.text }}</span>
                <p class="notice">{{ notice3 }}</p>
              </div>
            </div>
            <div class="protocol">
              <input
                type="checkbox"
                checked
                class="registerCheckbox"
                v-model="promise4"
              />
              <p>
                我已阅读并同意<a href="/protocol/index" target="_blank"
                  >《诺亚网络服务使用协议》</a
                >和<a href="/person/index" target="_blank"
                  >《个人信息保护协议》</a
                >
              </p>
            </div>
            <a class="submit-btn" @click="submit">立即认定</a>
          </div>
          <img
            v-if="!pageType"
            src="../../assets/images/close.png"
            class="close"
            @click="closeModal"
          />
        </div>
        <div class="modal-box" v-else-if="!moduleData.img_url_footer">
          <img :src="moduleData.img_url" class="modal-box-header" />
          <div class="modal-box-body">
            <div class="modal-box-left">
              <div class="describe">
                根据《私募投资基金募集行为管理办法》的规定，诺亚仅向特定合格投资者，宣传推介私募投资基金产品。
              </div>
              <div class="describe">
                如您个人或贵机构有意进行私募投资基金投资，请确认自身符合法律法规所规定的投资者标准：
              </div>
              <div class="protocols">
                <div class="protocol">
                  <input
                    type="checkbox"
                    class="registerCheckbox"
                    v-model="promise2"
                  />
                  <p>
                    本人/本机构承诺具备相应风险识别能力和风险承担能力，投资于单只私募基金的金额不低于100万元；
                  </p>
                </div>
                <div class="protocol">
                  <input
                    type="checkbox"
                    class="registerCheckbox"
                    v-model="promise3"
                  />
                  <p>
                    本人承诺个人金融类资产不低于300万元，或最近3年个人年均收入不低于50万元；本机构承诺净资产不低于1000万元；
                  </p>
                </div>
              </div>
            </div>
            <div class="modal-box-right">
              <div class="form-lists">
                <div class="form-list name">
                  <input
                    type="text"
                    v-model="name"
                    placeholder="请输入您的姓名"
                    @blur="verifyName"
                  />
                  <p class="notice">{{ notice1 }}</p>
                </div>
                <div class="form-list tel">
                  <input
                    type="tel"
                    v-model="phone"
                    placeholder="请输入您的手机号"
                    maxlength="11"
                    @blur="verifyPhone"
                  />
                  <p class="notice">{{ notice2 }}</p>
                </div>
                <div class="form-list vercode clearfix">
                  <input
                    type="tel"
                    v-model="phoneCode"
                    maxlength="6"
                    placeholder="请输入验证码"
                    @blur="verifyPhoneCode"
                  />
                  <span @click="getPhoneCode">{{ getPh.text }}</span>
                  <p class="notice">{{ notice3 }}</p>
                </div>
              </div>
              <div class="protocol">
                <input
                  type="checkbox"
                  checked
                  class="registerCheckbox"
                  v-model="promise4"
                />
                <p>
                  我已阅读并同意<a href="/protocol/index" target="_blank"
                    >《诺亚网络服务使用协议》</a
                  >和<a href="/person/index" target="_blank"
                    >《个人信息保护协议》</a
                  >
                </p>
              </div>
              <div class="submit-btn" @click="submit">立即认定</div>
            </div>
          </div>
        </div>
        <div class="modal-box-footer" v-else>
          <img :src="moduleData.img_url" class="modal-box-header" />
          <div class="modal-box-body">
            <div class="modal-box-left">
              <div class="describe">
                根据《私募投资基金募集行为管理办法》的规定，诺亚仅向特定合格投资者，宣传推介私募投资基金产品。
              </div>
              <div class="describe">
                如您个人或贵机构有意进行私募投资基金投资，请确认自身符合法律法规所规定的投资者标准：
              </div>
              <div class="protocols">
                <div class="protocol">
                  <input
                    type="checkbox"
                    class="registerCheckbox"
                    v-model="promise2"
                  />
                  <p>
                    本人/本机构承诺具备相应风险识别能力和风险承担能力，投资于单只私募基金的金额不低于100万元；
                  </p>
                </div>
                <div class="protocol">
                  <input
                    type="checkbox"
                    class="registerCheckbox"
                    v-model="promise3"
                  />
                  <p>
                    本人承诺个人金融类资产不低于300万元，或最近3年个人年均收入不低于50万元；本机构承诺净资产不低于1000万元；
                  </p>
                </div>
              </div>
            </div>
            <div class="modal-box-right">
              <div class="form-lists">
                <div class="form-list name">
                  <input
                    type="text"
                    v-model="name"
                    placeholder="请输入您的姓名"
                    @blur="verifyName"
                  />
                  <p class="notice">{{ notice1 }}</p>
                </div>
                <div class="form-list tel">
                  <input
                    type="tel"
                    v-model="phone"
                    placeholder="请输入您的手机号"
                    maxlength="11"
                    @blur="verifyPhone"
                  />
                  <p class="notice">{{ notice2 }}</p>
                </div>
                <div class="form-list vercode clearfix">
                  <input
                    type="tel"
                    v-model="phoneCode"
                    maxlength="6"
                    placeholder="请输入验证码"
                    @blur="verifyPhoneCode"
                  />
                  <span @click="getPhoneCode">{{ getPh.text }}</span>
                  <p class="notice">{{ notice3 }}</p>
                </div>
              </div>
              <div class="protocol">
                <input
                  type="checkbox"
                  checked
                  class="registerCheckbox"
                  v-model="promise4"
                />
                <p>
                  我已阅读并同意<a href="/protocol/index" target="_blank"
                >《诺亚网络服务使用协议》</a
                >和<a href="/person/index" target="_blank"
                >《个人信息保护协议》</a
                >
                </p>
              </div>
              <div class="submit-btn" @click="submit">立即认定</div>
            </div>
          </div>
          <img :src="moduleData.img_url_footer" class="modal-box-footer-img">
        </div>
      </div>
      <div v-if="step == 3">
        <smile-success v-if="moduleData.result_modal == 1" @close-modal="closeModal" />
        <mobile-success v-else-if="isMobile" @close-modal="closeModal" />
        <pc-success v-else @close-modal="closeModal" />
      </div>
    </div>
  </transition>
</template>

<script>
import md5 from "blueimp-md5";
import axios from "axios";
import util from "../../assets/js/util";
import encrypt, { Decrypt } from "../../api/encrypt";
import {getAccountInfo, traceLog} from "../../api/api";
import SmileSuccess from '../resultModal/smile-success'
import MobileSuccess from '../resultModal/mobile-success'
import PcSuccess from '../resultModal/pc-success'
import {getSearchString, saveExternalUser} from '../index'

let note = {};
function getQueryStringAll(params) {
  var str = location.search.substring(1).split("&");

  for (var i = 0; i < str.length; i++) {
    var val = str[i].split("=");
    if (!val[0]) break;
    params.note[val[0]] = val[1];
  }

  // params.partyId = params.note['partyId'] || '';
  params.note = JSON.stringify(params.note);

  return params;
}
function reducerData(params, note) {
  var result = JSON.parse(JSON.stringify(note));
  console.log(result);
  for (var item in params) {
    console.log(item);
    if (item == "note") break;
    result[item] = params[item];
  }
  result["activeId"] = "BAIDU_UP";

  return result;
}

let regName = /^[\u4e00-\u9fa5]{2,5}$/;
let regPhone = /^1[3456789]\d{9}$/;
let regPhoneCode = /[\d]{6}/;
export default {
  name: "appointment-qualification",
  components: {
    SmileSuccess,
    MobileSuccess,
    PcSuccess
  },
  data() {
    return {
      phone: "",
      phoneCode: "",
      imgCode: "",
      type: "209",
      notice1: "",
      notice2: "",
      notice3: "",
      promise1: true,
      promise2: true,
      promise3: true,
      promise4: false,
      real_name: "",
      card_no: "",
      name: "",
      getPh: {
        text: "获取验证码",
        boolean: false,
      },
      isMobile: util.device.isMobile,
      hasGroupNo: false,
      groupNo: '',
      submitLoading: false
    };
  },
  props: {
    step: {
      type: Number,
    },
    partyId: {
      type: String,
    },
    pageType: {
      type: Number,
    },
    pageName: {
      type: String,
    },
    showModal: {
      type: Boolean,
    },
    moduleData: {
      type: Object,
    },
    hasFa: {
      type: Boolean,
    },
    pageInfo: {
      type: Object,
    },
    needKYC: {
      type: Boolean,
    }
  },
  methods: {
    getPhoneCode() {
      if (this.getPh.boolean) return;
      util.ui.createWait();
      if (this.phone == "") {
        this.notice2 = "请输入您的手机号";
        util.ui.closeWait();
        return false;
      } else {
        if (!regPhone.test(this.phone)) {
          this.notice2 = "请输入11位手机号";
          util.ui.closeWait();
          return false;
        } else {
          this.notice2 = "";
          util
            .ajax({
              reqData: [
                {
                  method: "common.send_phone_code",
                  params: {
                    phone: this.phone,
                    method: "1",
                    type: this.type,
                  },
                },
              ],
            })
            .then((err, resArr) => {
              util.ui.closeWait();
              let second = 59;
              let inter = undefined;
              this.getPh.text = second + "秒后重发";
              this.getPh.boolean = true;
              inter = setInterval(() => {
                if (second == 0) {
                  this.getPh.text = "重新发送";
                  this.phoneCode = "";
                  clearInterval(inter);
                  this.getPh.boolean = false;
                } else {
                  second = second - 1;
                  this.$set(this.getPh, "text", second + "秒后重发");
                }
              }, 1000);
            });
        }
      }
    },
    verifyName() {
      if (this.name == "") {
        this.notice1 = "请输入姓名";
        return false;
      } else if (!regName.test(this.name)) {
        this.notice1 = "仅可输入2~5位中文姓名";
        return false;
      } else {
        this.notice1 = "";
        return true;
      }
    },
    verifyPhone() {
      if (this.phone == "") {
        this.notice2 = "请输入您的手机号";
        return false;
      } else if (!regPhone.test(this.phone)) {
        this.notice2 = "请输入正确的大陆手机号码";
        return false;
      } else {
        this.notice2 = "";
        return true;
      }
    },
    verifyPhoneCode() {
      if (this.phoneCode == "") {
        this.notice3 = "请输入验证码";
        return false;
      } else if (!regPhoneCode.test(this.phoneCode)) {
        this.notice3 = "请输入正确验证码";
        return false;
      } else {
        this.notice3 = "";
        return true;
      }
    },
    //投资者资格认证提交
    async submit() {
      // window._agl && window._agl.push(['track', ['success', {t: 3}]])
      this.notice1 = "";
      this.notice2 = "";
      this.notice3 = "";

      if (
        !this.verifyName() ||
        !this.verifyPhone() ||
        !this.verifyPhoneCode()
      ) {
        return;
      }
      if (!this.promise4) {
        this.$toast.show("请您阅读并同意相关协议", 2);
        return;
      }
      if (!this.promise1 || !this.promise2 || !this.promise3) {
        // this.notice3 = '请您勾选《合格投资者标准》'
        this.$toast.show("请您勾选合格投资者标准", 2);
        return;
      }
      if (this.submitLoading) return
      this.submitLoading = true

      var preParams = {
        mobilePhone: this.phone,
        name: this.name || "匿名",
        phoneCode: this.phoneCode,
        note: { partyId: this.partyId },
        partyId: this.partyId,
        city: this.$route.query.city || ""
      };

      var params = getQueryStringAll(preParams);
      console.log(params);
      var activeData = reducerData(params, { partyId: this.partyId });

      /**
       * 查询是否首次注册
       * 2021-04-29 zhl
       */
      const pubKey =
        "-----BEGIN PUBLIC KEY-----MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKwXxvLaOA1f/dVRQgS76HRrgRh8N7jqYScrSciQYtNtJ5hpCHmSHdjHXe4IK9lOT5SJHhZLXg/c2tFhvicoxAsCAwEAAQ==-----END PUBLIC KEY-----";
      const mobilePhone = encrypt(pubKey, this.phone);
      const infoData = await getAccountInfo({ phone: mobilePhone })
      if (infoData.data && infoData.data.code === 1) {
        this.hasGroupNo = infoData.data.data.hasGroupNo
        this.$emit('setFirstTime', this.hasGroupNo)
      }

      util
        .ajax({
          reqData: [
            {
              method: "active.baidu_potential_customer",
              params: params,
            },
          ],
        })
        .then((err, resArr) => {
          console.log(resArr);
          let bindParams = {
            mobilePhone: this.phone,
          };
          let sid = resArr[0].result;
          localStorage.setItem("sid", sid);
          console.log(bindParams);
          if (resArr[1].result && resArr[1].result.code == "0") {
            /**
             * 注册成功获取集团号
             * 2021-04-29 zhl
             */
            this.groupNo = resArr[1].result['group_no']
            this.$emit('setGroupNo', this.groupNo)
            saveExternalUser(this.phone, this.groupNo)
            util
              .ajax({
                header: { "X-KGW-SID": sid },
                reqData: [
                  {
                    method: "active.customer_is_bind_fa",
                    params: bindParams,
                  },
                ],
              })
              .then((err, resArr) => {
                console.log(resArr);
                console.log(resArr[1].result && resArr[1].result.isBindFa);
                this.submitLoading = false
                this.$emit(
                  "setHasFa",
                  !!resArr[1].result && resArr[1].result.isBindFa == "1"
                ); //isBindFa 1 有绑定的理财师
                // this.hasFa = !!resArr[1].result && resArr[1].result.isBindFa
                this.nextStep(1);

                let pubKey =
                  "-----BEGIN PUBLIC KEY-----MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKwXxvLaOA1f/dVRQgS76HRrgRh8N7jqYScrSciQYtNtJ5hpCHmSHdjHXe4IK9lOT5SJHhZLXg/c2tFhvicoxAsCAwEAAQ==-----END PUBLIC KEY-----";
                let phone = encrypt(pubKey, this.phone);
                console.log(phone);
                traceLog({
                  page_name: this.pageName, // 默认 为 0
                  user_name: this.name || "匿名",
                  phone: phone,
                  from_url: encodeURI(location.href), // 需要url编码
                }).then((resLog) => {
                  let reserveId = resLog.data.reserveId;
                  localStorage.setItem("reserveId", reserveId);
                });

                /**
                 * 投资认定成功埋点
                 */
                const needKYC = !!resArr[1].result && resArr[1].result.isBindFa == "1" ? '否' : this.needKYC ? '是' : '否'
                const external_userid = getSearchString('userid') && decodeURIComponent(getSearchString('userid'))
                const follow_user_state = getSearchString('followState') && decodeURIComponent(getSearchString('followState'))
                const fa_mail = getSearchString('inviteEmail') && decodeURIComponent(getSearchString('inviteEmail'))
                const fa_id = getSearchString('inviteUserid') && decodeURIComponent(getSearchString('inviteUserid'))
                const from_corp = getSearchString('fromCorp') && decodeURIComponent(getSearchString('fromCorp'))
                this.$sensors.track('pptf_profile_success', {
                  ...this.pageInfo,
                  needKYC: needKYC,
                  is_first_time: this.hasGroupNo ? '否' : '是',
                  customer_id: this.groupNo,
                  external_userid: external_userid ? Decrypt(external_userid) : '',
                  follow_user_state: follow_user_state ? Decrypt(follow_user_state) : '',
                  fa_mail: fa_mail ? Decrypt(fa_mail) : '',
                  fa_id: fa_id ? Decrypt(fa_id) : '',
                  from_corp: from_corp ? from_corp : ''
                })
              });
          } else {
            this.notice3 = resArr[1].error.message;
            this.submitLoading = false
            /**
             * 投资认定失败埋点
             */
            this.$sensors.track('pptf_profile_failed', {
              ...this.pageInfo
            })
          }
        });

      // util.ajax({
      //   reqData: [{
      //     "method": 'etc.get_rsa',
      //     "params": {
      //       type: '2'
      //     }
      //   }]
      // }).then((err, res) => {
      //   this.notice1 = '';
      //   if (res.result) {
      //     let pubKey = res.result.pubKey;
      //     pubKey = pubKey.replace(new RegExp("\n", "gm"), "");
      //     pubKey = pubKey.replace(new RegExp("\r", "gm"), "");
      //     var preParams = {
      //       mobilePhone: encrypt(pubKey, this.phone),
      //       name: this.name || '匿名',
      //       phoneCode: this.phoneCode,
      //       partyId: this.partyId,
      //       outCall: '1',
      //       faCode: '',
      //       fcCode: '',
      //       note
      //     };
      //     var params = getQueryStringAll(preParams);
      //     util.ajax({
      //       reqData: [{
      //         method: 'activity.mobile_login',
      //         params: params
      //       },{
      //         "method": "active.baidu_potential_customer",
      // 			  "params": params
      //       }]
      //     }).then((err, res) => {
      //       if (res.result && res.result.result == '1') {
      //         this.nextStep(1)
      //         traceLog({
      //           page_id: this.id, // 默认 为 0
      //           group_no: res.result.groupNo,
      //           from_url: location.href, // 需要url编码
      //         })
      //       } else {
      //         console.log(res.error)
      //         this.notice3 = res.error.message
      //       }
      //     })
      //   } else {
      //     console.log(err)
      //   }
      // })
    },
    //身份证认证 注册微诺亚会员
    nextStep(step) {
      this.$emit("setStep", step + 1);
    },
    closeModal() {
      this.phoneCode = "";
      this.$emit("setShowModal", false);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.app-modal-enter{
  opacity: 0;
}
.app-modal-enter-to{
  opacity: 1;
}
.app-modal-enter-active{
  transition: all 1s;
}
input:focus {
  outline: none;
  border: none;
}
.clearfix::before,
.clearfix::after {
  display: block;
  content: "";
  height: 0;
  clear: both;
}
.modal-wrapper {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
}
.mobile {
  .notice {
    font-size: 0.24rem;
    line-height: 0.3rem;
    color: red;
    text-align: center;
    margin-top: 0.2rem;
  }

  // .form-box .form-list.name {
  //   background-image: url(../../assets/images/iconName.png);
  // }

  // .form-box .form-list.tel {
  //   background-image: url(../../assets/images/iconTel.png);
  // }

  // .form-box .form-list.vercode {
  //   background-image: url(../../assets/images/iconVercode.png);
  //   float: left;
  // }

  .close {
    width: 0.48rem;
    height: 0.48rem;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -0.84rem;
  }

  .modal-wrapper {
    .modal-box {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 6.7rem;
      // height: 10.4rem;
      transform: translate(-50%, -50%);
      border-radius: 0.2rem;
      // background: linear-gradient(transparent 10%, #fff 10%);
      box-sizing: border-box;
    }

    .box-top {
      width: 100%;
      height: 5.12rem;
      border-radius: .2rem;
      background: linear-gradient(transparent 20%, #fff 0%);
      margin-top: -0.42rem;
    }

    .form-header {
      width: 6.7rem;
      height: 3.04rem;
      margin-top: -.41rem;
    }

    .form-txts {
      width: 6.1rem;
      height: 2rem;
      font-size: 0.24rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #323232;
      line-height: .33rem;
      margin: -.4rem auto 0;

      .form-txt-sign {
        text-align: right;
      }

      .protocol {
        width: 100%;
        height: 0.33rem;
        line-height: 0.33rem;
        font-size: 0.24rem;
        position: relative;
        margin: 0.1rem auto 0;
        display: flex;
        align-items: center;
        text-align: justify;

        p {
          // display: inline-block;
          position: absolute;
          left: 0.5rem;
        }
        a {
          text-decoration: none;
          color: #c49368;
        }

        .registerCheckbox {
          appearance: none;
          -webkit-appearance: none;
          vertical-align: middle;
          color: #808080;
          line-height: 1;
          outline: 0;
          width: 0.3rem;
          height: 0.3rem;
          background: url("../../assets/images/agree-no.png") center / contain
            no-repeat;
          position: absolute;
          top: 0.02rem;
        }

        .registerCheckbox:checked::before {
          display: block;
          width: 0.3rem;
          height: 0.3rem;
          content: "";
          background: url("../../assets/images/agree-yes.png") center / contain
            no-repeat;
          color: #000;
          font-size: 0.24rem;
        }
      }
    }

    .form-rings {
      width: 6.32rem;
      height: 0.72rem;
      background: url("../../assets/images/form-rings.png") center / contain
        no-repeat;
      position: relative;
      z-index: 2;
      margin: -0.3rem auto;
    }

    .form-box {
      width: 6.7rem;
      // height: 5.6rem;
      background: #fff;
      border-radius: 0.2rem;
      overflow: hidden;

      .form-lists {
        height: 3.9rem;
        margin-top: 0.1rem;
      }

      .form-list {
        width: 80%;
        height: 1.3rem;
        line-height: 1.3rem;
        box-sizing: border-box;
        background-position: 0.1rem 0.47rem;
        background-size: 0.36rem 0.36rem;
        background-repeat: no-repeat;
        border: none;
        border-bottom: 0.01rem solid #e6e6e6;
        border-radius: 0;
        margin: 0 auto;
        position: relative;
      }

      .form-list input {
        margin: 0.45rem 0 0.45rem 0rem;
        font-size: 0.3rem;
        background: transparent;
        height: 0.4rem;
        line-height: 0.4rem;
        width: 100%;
        color: #323232;
        border: none;
        outline: none;
        vertical-align: top;
      }

      // .vercode.form-list {
      //   left: 50%;
      //   transform: translateX(-50%);
      // }

      .vercode.form-list input {
        width: 3.8rem;
      }

      .vercode.form-list > span {
        float: right;
        width: 1.5rem;
        height: 1.3rem;
        line-height: 1.3rem;
        color: #c49368;
        font-size: 0.28rem;
        text-align: right;
        float: right;
        background: transparent;
      }

      .form-list p {
        position: absolute;
        top: 0.88rem;
        left: 0rem;
        margin-top: 0;
      }

      .vercode.form-list > img {
        float: right;
        width: 2.1rem;
        height: 0.88rem;
      }

      .submit-btn {
        width: 5.1rem;
        height: 0.8rem;
        border-radius: 0.44rem;
        background: linear-gradient(315deg, #c49368 0%, #e3bb98 100%);
        box-shadow: 0 0.04rem 0.08rem 0 rgba(227, 187, 152, 0.4);
        display: block;
        line-height: 0.8rem;
        font-size: 0.32rem;
        font-weight: 400;
        margin: 0.4rem auto;
        text-align: center;
        color: #fff;
        text-decoration: none;
      }
    }
  }

  .protocol {
    width: 80%;
    height: 0.66rem;
    line-height: 0.28rem;
    font-size: 0.24rem;
    position: relative;
    // color: #c49368;
    margin: 25px auto;
    p {
      position: absolute;
      left: 0.5rem;
    }
    a {
      text-decoration: none;
      color: #c49368;
    }

    .registerCheckbox {
      appearance: none;
      -webkit-appearance: none;
      vertical-align: middle;
      color: #808080;
      line-height: 1;
      outline: 0;
      border-radius: 0;
      width: 0.3rem;
      height: 0.3rem;
      background: url("../../assets/images/agree-no-pc.png") center / contain
        no-repeat;
      position: absolute;
      top: 0.042rem;
      left: 0;
      cursor: pointer;
    }

    .registerCheckbox:checked::before {
      display: block;
      width: 0.3rem;
      height: 0.3rem;
      content: "";
      background: url("../../assets/images/agree-yes-pc.png") center / contain
        no-repeat;
      color: #000;
      font-size: 0.337rem;
    }
  }
}

.pc {
  .close {
    width: 0.64rem;
    height: 0.64rem;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -0.84rem;
    cursor: pointer;
  }

  .modal-wrapper {
    .notice {
      font-size: 0.169rem;
      line-height: 0.28rem;
      color: red;
      text-align: center;
      position: absolute;
      left: 0.13rem;
      top: 0.562rem;
    }
    .modal-box {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 9.84rem;
      height: 6.536rem;
      transform: translate(-50%, -50%);
      border-radius: 0.056rem;
      box-sizing: border-box;
    }

    .modal-box-header {
      width: 100%;
      height: 2.28rem;
      position: absolute;
      top: -0.31rem;
      left: 0;
    }

    .modal-box-body {
      width: 100%;
      height: 6.536rem;
      display: flex;
    }

    .modal-box-left {
      width: 4.92rem;
      height: 6.536rem;
      background: linear-gradient(transparent 0.3rem, #fafafa 0.3rem);
      padding-top: 2.08rem;
      box-sizing: border-box;
      border-top-left-radius: 0.056rem;
      border-bottom-left-radius: 0.056rem;

      .describe {
        width: 4.217rem;
        font-size: 0.197rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #323232;
        line-height: 0.28rem;
        margin-left: 0.42rem;
        text-align: justify;
      }

      .protocols {
        margin-top: 0.576rem;
      }

      .protocol {
        width: 4.217rem;
        height: 0.843rem;
        line-height: 0.28rem;
        font-size: 0.197rem;
        margin-left: 0.422rem;
        margin-bottom: 0.365rem;
        position: relative;
        color: #c49368;
        text-align: justify;

        p {
          position: absolute;
          left: 0.422rem;
        }
        a {
          text-decoration: none;
          color: #c49368;
        }

        .registerCheckbox {
          appearance: none;
          -webkit-appearance: none;
          vertical-align: middle;
          color: #808080;
          line-height: 1;
          outline: 0;
          width: 0.197rem;
          height: 0.197rem;
          background: url("../../assets/images/agree-no-pc.png") center /
            contain no-repeat;
          position: absolute;
          top: 0.042rem;
          cursor: pointer;
        }

        .registerCheckbox:checked::before {
          display: block;
          width: 0.197rem;
          height: 0.197rem;
          content: "";
          background: url("../../assets/images/agree-yes-pc.png") center /
            contain no-repeat;
          color: #000;
          font-size: 0.337rem;
        }
      }
    }

    .modal-box-right {
      width: 4.92rem;
      height: 6.536rem;
      background: linear-gradient(transparent 0.3rem, #fafafa 0.3rem);
      padding-top: 2.08rem;
      box-sizing: border-box;
      border-top-right-radius: 0.056rem;
      border-bottom-right-radius: 0.056rem;

      .form-lists {
        height: 2.249rem;

        .form-list {
          width: 4.217rem;
          height: 0.562rem;
          line-height: 0.562rem;
          box-sizing: border-box;
          background-position: 0 0.056rem;
          background-size: 0.45rem 0.45rem;
          background-repeat: no-repeat;
          border: none;
          border-radius: 0;
          margin: 0 auto;
          position: relative;
          margin-bottom: 0.28rem;
        }

        .form-list input {
          width: 100%;
          height: 0.562rem;
          line-height: 0.562rem;
          // margin-left: 0.73rem;
          font-size: 0.197rem;
          background: transparent;
          color: #303133;
          border: 1px solid #dcdfe6;
          outline: none;
          vertical-align: top;
          border-radius: 0.056rem;
          padding-left: 0.211rem;
          box-sizing: border-box;
        }

        .form-list input:focus {
          border: 1px solid #e3bb98;
        }

        // .vercode.form-list {
        //   left: 50%;
        //   transform: translateX(-50%);
        // }

        .vercode.form-list > span {
          float: right;
          width: 1.32rem;
          height: 0.281rem;
          line-height: 0.281rem;
          color: #c49368;
          font-size: 0.197rem;
          text-align: center;
          border-left: 1px solid #dcdfe6;
          position: absolute;
          right: 0;
          top: 0.141rem;
        }

        // .form-list.name {
        //   background-image: url(../../assets/images/iconName.png);
        // }

        // .form-list.tel {
        //   background-image: url(../../assets/images/iconTel.png);
        // }

        // .form-list.vercode {
        //   background-image: url(../../assets/images/iconVercode.png);
        //   float: left;
        // }
      }

      .submit-btn {
        width: 4.217rem;
        height: 0.562rem;
        line-height: 0.562rem;
        border-radius: 0.281rem;
        background: linear-gradient(315deg, #c49368 0%, #e3bb98 100%);
        font-size: 0.197rem;
        font-weight: 500;
        margin: 0.762rem auto 0.422rem;
        text-align: center;
        color: #fff;
        cursor: pointer;
      }

      .protocol {
        width: 4.217rem;
        height: 0.239rem;
        line-height: 0.239rem;
        font-size: 0.167rem;
        margin: 0 auto;
        position: relative;
        color: #303133;

        p {
          position: absolute;
          top: 0.328rem;
          left: 0.337rem;
        }
        a {
          text-decoration: none;
          color: #c49368;
        }

        .registerCheckbox {
          appearance: none;
          -webkit-appearance: none;
          vertical-align: middle;
          color: #808080;
          line-height: 1;
          outline: 0;
          border-radius: 0;
          width: 0.23rem;
          height: 0.23rem;
          background: url("../../assets/images/agree-no-pc.png") center /
            contain no-repeat;
          position: absolute;
          top: 0.328rem;
          cursor: pointer;
        }

        .registerCheckbox:checked::before {
          display: block;
          width: 0.23rem;
          height: 0.23rem;
          content: "";
          background: url("../../assets/images/agree-yes-pc.png") center /
            contain no-repeat;
          color: #000;
          font-size: 0.337rem;
        }
      }
    }

    .modal-box-footer {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 10.44rem;
      height: 8.0rem;
      transform: translate(-50%, -50%);
      border-radius: 0.056rem;
      box-sizing: border-box;
      overflow: hidden;
      .modal-box-header {
        width: 100%;
        height: 1.08rem;
        position: absolute;
        top: 0;
        left: 0;
      }

      .modal-box-body {
        width: 100%;
        height: 5.2rem;
        display: flex;
      }

      .modal-box-left {
        width: 5.22rem;
        height: 5.2rem;
        background: linear-gradient(transparent 0.3rem, #fafafa 0.3rem);
        padding-top: 1.08rem;
        box-sizing: border-box;
        //border-top-left-radius: 0.056rem;
        border-bottom-left-radius: 0rem;

        .describe {
          width: 4.48rem;
          font-size: 0.17rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #323232;
          line-height: 0.36rem;
          margin-left: 0.42rem;
          text-align: justify;
          &:nth-child(1) {
            margin-top: 0.24rem;
          }
        }

        .protocols {
          margin-top: 0.24rem;
        }

        .protocol {
          width: 4.48rem;
          height: 0.72rem;
          line-height: 0.36rem;
          font-size: 0.17rem;
          margin-left: 0.422rem;
          margin-bottom: 0.16rem;
          position: relative;
          color: #c49368;
          text-align: justify;
          &:nth-child(2) {
            height: 1.08rem;
          }

          p {
            position: absolute;
            left: 0.38rem;
          }
          a {
            text-decoration: none;
            color: #c49368;
          }

          .registerCheckbox {
            appearance: none;
            -webkit-appearance: none;
            vertical-align: middle;
            color: #808080;
            line-height: 1;
            outline: 0;
            width: 0.185rem;
            height: 0.185rem;
            background: url("../../assets/images/agree-no-pc.png") center /
            contain no-repeat;
            position: absolute;
            top: 0.042rem;
            cursor: pointer;
          }

          .registerCheckbox:checked::before {
            display: block;
            width: 0.185rem;
            height: 0.185rem;
            content: "";
            background: url("../../assets/images/agree-yes-pc.png") center /
            contain no-repeat;
            color: #000;
            font-size: 0.337rem;
          }
        }
      }

      .modal-box-right {
        width: 5.22rem;
        height: 5.2rem;
        background: linear-gradient(transparent 0.3rem, #fafafa 0.3rem);
        padding-top: 1.08rem;
        box-sizing: border-box;
        //border-top-right-radius: 0.056rem;
        border-bottom-right-radius: 0rem;

        .form-lists {
          height: 2.295rem;
          margin-top: 0.28rem;

          .form-list {
            width: 4.217rem;
            height: 0.525rem;
            line-height: 0.525rem;
            box-sizing: border-box;
            background-position: 0 0.056rem;
            background-size: 0.45rem 0.45rem;
            background-repeat: no-repeat;
            border: none;
            border-radius: 0;
            margin: 0 auto;
            position: relative;
            margin-bottom: 0.24rem;

            .notice {
              font-size: 0.17rem;
              line-height: 0.24rem;
              top: 0.525rem;
            }
          }

          .form-list input {
            width: 100%;
            height: 0.525rem;
            line-height: 0.525rem;
            // margin-left: 0.73rem;
            font-size: 0.17rem;
            background: transparent;
            color: #303133;
            border: 1px solid #dcdfe6;
            outline: none;
            vertical-align: top;
            border-radius: 0.056rem;
            padding-left: 0.211rem;
            box-sizing: border-box;
          }

          .form-list input:focus {
            border: 1px solid #e3bb98;
          }

          // .vercode.form-list {
          //   left: 50%;
          //   transform: translateX(-50%);
          // }

          .vercode.form-list > span {
            float: right;
            width: 1.32rem;
            height: 0.281rem;
            line-height: 0.281rem;
            color: #c49368;
            font-size: 0.197rem;
            text-align: center;
            border-left: 1px solid #dcdfe6;
            position: absolute;
            right: 0;
            top: 0.141rem;
          }

          // .form-list.name {
          //   background-image: url(../../assets/images/iconName.png);
          // }

          // .form-list.tel {
          //   background-image: url(../../assets/images/iconTel.png);
          // }

          // .form-list.vercode {
          //   background-image: url(../../assets/images/iconVercode.png);
          //   float: left;
          // }
        }

        .submit-btn {
          width: 4.217rem;
          height: 0.525rem;
          line-height: 0.525rem;
          border-radius: 0.281rem;
          background: linear-gradient(315deg, #c49368 0%, #e3bb98 100%);
          font-size: 0.17rem;
          font-weight: 500;
          margin: 0.12rem auto 0.28rem;
          text-align: center;
          color: #fff;
          cursor: pointer;
        }

        .protocol {
          width: 4.217rem;
          height: 0.6rem;
          line-height: 0.3rem;
          font-size: 0.17rem;
          margin: 0 auto;
          position: relative;
          color: #303133;

          p {
            position: absolute;
            top: 0rem;
            left: 0.337rem;
          }
          a {
            text-decoration: none;
            color: #c49368;
          }

          .registerCheckbox {
            appearance: none;
            -webkit-appearance: none;
            vertical-align: middle;
            color: #808080;
            line-height: 1;
            outline: 0;
            border-radius: 0;
            width: 0.23rem;
            height: 0.23rem;
            background: url("../../assets/images/agree-no-pc.png") center /
            contain no-repeat;
            position: absolute;
            top: 0.04rem;
            cursor: pointer;
          }

          .registerCheckbox:checked::before {
            display: block;
            width: 0.23rem;
            height: 0.23rem;
            content: "";
            background: url("../../assets/images/agree-yes-pc.png") center /
            contain no-repeat;
            color: #000;
            font-size: 0.337rem;
          }
        }
      }

      .modal-box-footer-img {
        width: 100%;
        height: 2.81rem;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/appointment-qualification.vue